import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/ui/Button';
import '../styles/pages/AboutPage.css';

export default function AboutPage() {
  return (
    <main className="about-page">
      <header className="about-hero">
        <h1>About ViewFinders</h1>
        <p className="about-intro">
          ViewFinders brings photographer discovery, conversations, bookings and
          payments together in one place.
        </p>
        <p>
          We’re building it to help clients find photographers whose work suits
          their needs, and give photographers somewhere to showcase their work
          and manage enquiries.
        </p>
      </header>

      <section className="about-section" aria-labelledby="about-audience-heading">
        <h2 id="about-audience-heading">Who it’s for</h2>
        <div className="about-audiences">
          <div className="about-card">
            <h3>For clients</h3>
            <p>
              Finding a photographer starts with finding work you connect with.
              ViewFinders gives you a place to explore portfolios, get to know
              the photographer and discuss what you have in mind, with your
              booking details and conversations kept together.
            </p>
          </div>
          <div className="about-card">
            <h3>For photographers</h3>
            <p>
              Your work is at the centre of your profile. Alongside your
              portfolio, ViewFinders brings client conversations, upcoming
              bookings, availability and a payment summary into your workspace,
              helping you keep track of the work coming your way.
            </p>
          </div>
        </div>
      </section>

      <section className="about-section" aria-labelledby="about-team-heading">
        <h2 id="about-team-heading">Who’s building this</h2>
        <div className="about-team">
          <div className="about-team-member">
            <span className="about-team-avatar" aria-hidden="true">R</span>
            <div><h3>Rhys Griffiths-Irvine</h3><p>Founder / Software Engineering</p></div>
          </div>
          <div className="about-team-member">
            <span className="about-team-avatar" aria-hidden="true">S</span>
            <div><h3>Samuel Brunt</h3><p>Founder / Operations</p></div>
          </div>
        </div>
      </section>

      <section className="about-stage" aria-labelledby="about-stage-heading">
        <h2 id="about-stage-heading">Where we are today</h2>
        <p>
          ViewFinders is an early-stage project and active demo. We’re continuing
          to refine the experience as we build, and feedback from people trying
          it helps us understand what to improve next.
        </p>
        <p>
          If you’ve tried the site or have something you’d like to share,
          we’d like to <Link to="/contact">hear from you</Link>.
        </p>
      </section>

      <nav className="about-links" aria-label="Explore ViewFinders">
        <Button as="link" to="/" variant="primary" size="lg">Find photographers</Button>
        <Button as="link" to="/help" variant="secondary" size="lg">How ViewFinders works</Button>
        <Link to="/contact">Contact us</Link>
      </nav>
    </main>
  );
}
